module.exports = __webpack_public_path__ + "img/RJMT_fb.7a928542.svg";